import { render, staticRenderFns } from "./PppPDFJSViewer.vue?vue&type=template&id=3efd68f3&"
import script from "./PppPDFJSViewer.vue?vue&type=script&lang=js&"
export * from "./PppPDFJSViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports